import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "enterDirection", "showTransition", "transitionStatus"];
import { ClassNames } from "@emotion/core";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React, { forwardRef } from "react";
import { TooltipContainer } from "../components/TooltipContainer";
import { tooltipTheme } from "../tooltipTheme";
var slideTransitionStyles = {
  top: {
    transform: "translateY(4px)"
  },
  bottom: {
    transform: "translateY(-4px)"
  },
  left: {
    transform: "translateX(4px)"
  },
  right: {
    transform: "translateX(-4px)"
  }
};
/**
 * This component's job is to apply the correct animations and border radius to the Tooltip.
 */
export var TooltipFlyoutContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    enterDirection = _ref.enterDirection,
    showTransition = _ref.showTransition,
    transitionStatus = _ref.transitionStatus,
    props = _objectWithoutProperties(_ref, _excluded);
  var themeMode = useCombinedThemeMode();
  var slideTransition = "transform ".concat(tooltipTheme.motion.slide(themeMode));
  var opacityTransition = "opacity ".concat(tooltipTheme.motion.opacity(themeMode));
  return /*#__PURE__*/React.createElement(ClassNames, null, function (_ref2) {
    var css = _ref2.css;
    return /*#__PURE__*/React.createElement(TooltipContainer, _extends({}, props, {
      ref: ref,
      className: css({
        opacity: transitionStatus === "entered" ? 1 : 0,
        transform: transitionStatus === "entering" && enterDirection !== "auto" ? slideTransitionStyles[enterDirection].transform : "translateY(0) translateX(0)",
        // Always show opacity, slide transition nees to happen AFTER the first popper update.
        transition: "".concat(opacityTransition, ", ").concat(showTransition ? slideTransition : "")
      })
    }), children);
  });
});
TooltipFlyoutContainer.displayName = "TooltipFlyoutContainer";
//# sourceMappingURL=TooltipFlyoutContainer.js.map